import { Link } from 'react-router-dom'
import { Bike } from 'lucide-react'
import { useSettings } from '@/modules/settings-api'

export function Logo() {
  const { data: settings } = useSettings()
  return (
    <Link to="/" className="flex items-center gap-3 shrink-0">
      <div className="w-12 h-12 rounded-xl bg-brand-600 flex items-center justify-center text-white overflow-hidden">
        {settings.logoUrl ? (
          <img
            src={settings.logoUrl}
            alt={settings.shopName}
            className="w-full h-full object-contain"
            onError={(e) => { (e.target as HTMLImageElement).style.display = 'none' }}
          />
        ) : (
          <Bike className="w-7 h-7" strokeWidth={2.2} />
        )}
      </div>
      <div className="leading-tight">
        <div className="text-xl font-bold text-brand-600">{settings.shopName}</div>
        <div className="text-xs text-muted">{settings.slogan}</div>
      </div>
    </Link>
  )
}
